<template>
  <v-breadcrumbs :items="items">
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item
          :to="item.href"
          :disabled="item.disabled"
      >
        {{ item.text.toUpperCase() }}
      </v-breadcrumbs-item>
    </template>
    <div class="card_container" >
      <div class="card_header" >
        <div>ข้อมูลแผนก</div>
        <div>
        </div>

      </div>

      <v-breadcrumbs :items="items">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
              :to="item.href"
              :disabled="item.disabled"
          >
            {{ item.text.toUpperCase() }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
      <div class="form_action" >
        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
        >
          <v-text-field
              v-model="title"
              :rules="[v => !!v || 'กรุณากรอกชื่อแผนก']"
              label="ชื่อแผนก"
              required
          ></v-text-field>

          <div align="center" style="margin-top: 2rem" >
            <v-btn v-if="!edit"
                color="success"
                class="mr-4"
                @click="validate"
            >
              เพิ่มข้อมูล
            </v-btn>

            <v-btn v-if="edit"
                   color="success"
                   class="mr-4"
                   @click="validate"
            >
              แก้ไขข้อมูล
            </v-btn>

            <v-btn
                color="error"
                class="mr-4"
                @click="reset"
            >
              ล้างค่า
            </v-btn>

            <v-btn v-if="edit"
                color="error"
                class="mr-4"
                @click="resetedit"
            >
              ยกเลิกแก้ไข
            </v-btn>


          </div>


        </v-form>
      </div>


      <v-data-table
          :headers="headers"
          :items="resultData"
          sort-by="calories"
          class="elevation-1"
      >
        <template v-slot:top>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon
              small
              class="mr-2"
              @click="editItem(item._id,item.title)"
          >
            mdi-pencil
          </v-icon>
          <v-icon
              small
              @click="deleteItem(item._id)"
          >
            mdi-delete
          </v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn
              color="primary"
              @click="initialize"
          >
            Reset
          </v-btn>
        </template>
      </v-data-table>
    </div>
  </v-breadcrumbs>



</template>

<script>
import {AddDepartment, DeleteDepartment, GetDepartment, UpdateDepartment} from "../../lib/controller";
import {baseUrl} from "../../const/api";



export default {
  name: "Users",
  data: () => ({
    baseUrl:baseUrl,
    valid: true,
    edit:false,
    id:false,
    title:"",
    items: [
      {
        text: 'Home',
        disabled: false,
        href: '/',
      },
      {
        text: 'ข้อมูลแผนก',
        disabled: true,
        href: '/Department',
      },
    ],
    dialog: false,
    dialogDelete: false,
    headers: [
      { text: 'ชื่อ', value: 'title' },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
    desserts: [],
    editedIndex: -1,
    resultData:[],
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },
  },
  watch: {

  },
  created () {
    this.initialize()
    this.getData()
  },

  methods: {
    async editItem(id,title) {
      this.edit = true;
      this.title = title;
      this.id = id;
      console.log(id)
    },
    async resetedit() {
      this.edit = false;
      this.title = "";
    },
    async deleteItem(id){
      console.log(id)
      this.$swal({
        title: 'ต้องการลบใช่หรือไม่ ?',
        showCancelButton: true,
        confirmButtonText: 'ตกลง',
        cancelButtonText:"ยกเลิก",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.delete(id)
        }
      })

      ;
    },
    initialize () {

    },
    async getData(){
      const { status,results } = await GetDepartment();
      if(status === 200){
        this.resultData = results.data;
      }
    },
    async delete(id){
      let Swal = this.$swal;
      const { status } = await DeleteDepartment(id);
      if(status === 200){
        Swal({
          icon: 'success',
          title: 'Success',
        })
        await this.getData()
      }
    },
   async validate () {
      console.log(this.file)
      if(this.$refs.form.validate()){
       await this.AddUpdate();
      }
    },
    reset () {
      this.$refs.form.reset()
    },
   async AddUpdate(){

      console.log("AddUpdate")

     let formData = new FormData();
     formData.append("title",this.title);

     let Swal = this.$swal;
      if(!this.edit){



        const { status  } = await  AddDepartment(formData);
        if(status === 200){
          Swal({
            icon: 'success',
            title: 'Success',
          })
         await this.getData();
        }

      }else{

        const { status  } = await  UpdateDepartment(this.id,formData);
        if(status === 200){
          await this.getData();
        }

      }

    }
  },
}


</script>

<style scoped>
.card_container{
  width: 100%;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #ffffff;
  background-clip: border-box;
  border: 1px solid #EBEDF3;
  border-radius: 0.42rem;
}
.card_header{
  padding: 1.5rem 2rem;
  margin-bottom: 0;
  background-color: #ffffff;
  border-bottom: 1px solid #EBEDF3;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.img_thumb{
  width:8rem;
  border-radius:10px;
  margin:0.2rem;
}
.form_action{
  padding-right: 5rem;
  padding-left: 5rem;
}
</style>
